import React from "react";

import makeStyles from '@mui/styles/makeStyles';
import CircularProgress from "@mui/material/CircularProgress";

// sections for this page
import Images from "../index-sections/Images.js";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    "& > * + *": {
      marginLeft: theme.spacing(2),
    },
  },
}));
const HomePage = (props) => {
  const classes = useStyles();
  React.useEffect(() => {}, []);

  return (
    <>
      {/* <CircularProgress color="info" /> */}
      <Images />
    </>
  );
};

export default HomePage;
